import ArticleSchema from "./ArticleSchema";

export default ArticleSchema;
